const intersection = require('lodash/intersection');

window.addEventListener('alpine:init', () => bootstrap());

if (
	window.wpexEqualHeights
	&& typeof window.wpexEqualHeights === 'function'
) {
	setupEqualHeightsProxy();
}

function setupEqualHeightsProxy() {
	// Only setup for the post cards component
	if (!document.querySelector('.js-alpine-post-cards')) { return; }

	const real_wpexEqualHeights = window.wpexEqualHeights;
	window.wpexEqualHeights = (parent, child, context) => {
		// Guard
		if (
			typeof parent !== 'string'
			|| typeof child !== 'string'
		) {
			return real_wpexEqualHeights(parent, child, context);
		}

		// See if we actually need to run...
		let should_run = false;
		document.querySelectorAll(parent).forEach($parent => {
			if ($parent.querySelectorAll(child).length > 0) {
				should_run = true;
			}
		});

		if (should_run) {
			real_wpexEqualHeights(parent, child, context);
		}
	};
}

export default (
) => ({
	cards: [],
	selected_topics: [],
	selected_subtopics: [],
	selected_types: [],
	no_posts_message: 'No posts found',
	ad: null,
	media: null,
	init() {
		this.no_posts_message = this.$refs?.no_posts_message?.textContent ?? '';
		this.setupMedia();
		this.setupAd();
		this.$nextTick(() => queueMicrotask(() => this.setupCards()));
		// this.setupCards();
	},
	setupMedia() {
		const $media = document.querySelector('.js-post-card-media');
		if ($media) {
			this.media = {
				content: $media.innerHTML,
				class: $media.getAttribute('class') + ' post-card-media',
			};
			$media.remove();
		}
	},
	setupAd() {
		const $ad = document.querySelector('.js-post-card-ad');
		if ($ad) {
			this.ad = {
				content: $ad.innerHTML,
				class: $ad.getAttribute('class') + ' post-card-ad',
			};
			$ad.remove();
		}
	},
	filter() {
		if (this.$event.detail.field === 'topic') {
			this.selected_topics = this.$event.detail.topics;
		}

		if (this.$event.detail.field === 'subtopic') {
			this.selected_subtopics = this.$event.detail.subtopics;
		}

		if (this.$event.detail.field === 'type') {
			this.selected_types = this.$event.detail.types;
		}

		this.track();
	},
	setupCards() {
		this.cards = Array.from(this.$root.children)
			.filter(el => el.tagName === 'DIV')
			.filter(el => !el.classList.contains('js-post-card-newsletter-signup'))
			.map(el => {
				const klass = el.getAttribute('class');
				const klass_list = Array.from(el.classList);
				const entry = {
					class: klass,
					content: el.innerHTML.replace(' skeleton"', '"'),
					topics: klass_list
						.filter(_ => _.startsWith('resource_topic-'))
						.map(_ => _.substr(15)),
					types: klass_list
						.filter(_ => _.startsWith('resource_type-'))
						.map(_ => _.substr(14)),
				};
				if (klass_list.includes('type-post')) {
					entry.types.push('blog');
				}
				if (
					klass_list.includes('type-press_release')
					|| klass_list.includes('type-media-coverage')
				) {
					entry.types.push('newsroom');
				}

				el.remove();
				return entry;
			});
	},
	track() {
		window.dataLayer = window.dataLayer || [];
		const page_url = window.location.protocol + '//' + window.location.host + window.location.pathname;

		window.dataLayer.push({
			event: 'filter',
			eventCategory: 'resources',
			filterTopic: this.selected_topics,
			filterSubtopic: this.selected_subtopics,
			filterType: this.selected_types,
			pageUrl: page_url,
		});
	},
	get ad_index() {
		return 4;
	},
	get media_index() {
		if (this.ad) {
			return 8;
		}
		return 4;
	},
	get filtered_cards_with_extras() {
		let cards = [...this.filtered_cards];

		if (this.ad && cards.length >= this.ad_index) {
			cards.splice(this.ad_index, 0, this.ad);
		}

		if (this.media && cards.length >= this.media_index) {
			cards.splice(this.media_index, 0, this.media);
			this.$nextTick(() => window.vcexCarousels());
		}


		return cards;
	},
	get filtered_cards() {
		if (
			this.selected_topics.length === 0
			&& this.selected_subtopics.length === 0
			&& this.selected_types.length === 0
		) {
			this.$dispatch(
				'available-types',
				[...new Set(this.cards.flatMap(_ => _.types))]
			);
			this.$dispatch(
				'available-topics',
				[...new Set(this.cards.flatMap(_ => _.topics))]
			);
			return this.cards;
		}

		let cards = this.cards;

		if (this.selected_types.length > 0) {
			cards = cards.filter(_ => intersection(_.types, this.selected_types).length > 0);
		}

		this.$dispatch(
			'available-topics',
			[...new Set(cards.flatMap(_ => _.topics))]
		);

		if (this.selected_topics.length > 0) {
			cards = cards.filter(_ => intersection(_.topics, this.selected_topics).length > 0);
		}

		if (this.selected_subtopics.length > 0) {
			cards = cards.filter(_ => intersection(_.topics, this.selected_subtopics).length > 0);
		}

		this.$dispatch(
			'available-types',
			[...new Set(cards.flatMap(_ => _.types))]
		);

		return cards;
	},
});

function bootstrap() {
	document.querySelectorAll('.js-alpine-post-cards')
		.forEach($el => bootstrapPostCards($el))
	;
}

function bootstrapPostCards($el) {
	const $root = $el.querySelector('.wpex-post-cards-loop');

	$root.setAttribute('x-data', 'postCards');
	$root.setAttribute('x-on:filter.window', 'filter');
	// $root.setAttribute('x-on:message.window', 'message');
	$root.insertAdjacentHTML(
		'afterbegin',
		'<p class="no-posts-message" x-text="no_posts_message" x-show="filtered_cards.length === 0 && cards.length > 0" />'
	);
	$root.insertAdjacentHTML(
		'afterbegin',
		'<template x-for="card in filtered_cards_with_extras"><div :class="card.class" x-html="card.content"></div></template>'
	);
	const $newsletter_signup = document.querySelector('.js-post-card-newsletter-signup');
	if ($newsletter_signup) {
		$newsletter_signup.setAttribute('x-show', 'filtered_cards.length > 0');
		$root.prepend($newsletter_signup);
		$newsletter_signup.style.display = 'block';
	}
}

